import { useQuery } from "@tanstack/react-query";
import type { RecordSummary } from "@shared/recordSummary";

function useSummary(kind: "contact" | "company", id: string | undefined) {
  return useQuery<RecordSummary>({
    queryKey: ["record-summary", kind, id],
    queryFn: async () => {
      const r = await fetch(`/api/${kind === "contact" ? "contacts" : "companies"}/${id}/record-summary`, { credentials: "include" });
      if (!r.ok) throw new Error("Failed to load summary");
      return r.json();
    },
    enabled: !!id,
    staleTime: 60_000,
  });
}

/** Brief, open items and FTC contact for a person's page. Logging an activity refreshes it. */
export const useContactSummary = (contactId: string | undefined) => useSummary("contact", contactId);

/** The same for a company page: its own rows plus everything involving its people. */
export const useCompanySummary = (companyId: string | undefined) => useSummary("company", companyId);
